import { colors } from '../../../theme/color-palette';
import { makeStyles } from '@material-ui/core';
const { PURPLE, GREY } = colors;

export const useItemGridStyles = makeStyles(() => ({
	tableHeader: {
		cursor: 'pointer',
		textTransform: 'none',
		paddingLeft: (props) => props.paddingLeft,
		fontFamily: 'Bogle-Medium',
		fontSize: (props) => props.fontSize,
		color: '#6D6E71',
	},
	tableCellFonts: {
		fontFamily: 'Bogle-Regular',
		fontSize: (props) => props.fontSize,
	},
	tableHeaderCellRow2: {
		fontFamily: 'Bogle-Regular',
		fontSize: '12px',
	},
	tableCell: {
		borderBottom: 'none',
		paddingRight: (props) => props.paddingRight,
	},
	headerCell: {
		padding: '0px',
	},
	spanHeader: {
		marginTop: '-30px',
	},
	sortIcon: {
		'& svg': {
			opacity: '1',
			color: GREY,
		},
	},
	sortIconActive: {
		'& svg': {
			opacity: '1',
			color: PURPLE,
		},
	},
}));
